import React, { useContext } from 'react';
import { Menu } from 'antd';
import { arrayOf, any } from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { MdKeyboardBackspace } from 'react-icons/md';
import { UiContext, AuthContext, toggleCollapsedSideNav } from '../../../appContext';
import CustomScrollbars from '../../../util/CustomScrollbars';
import SidebarLogo from './SidebarLogo';
import { NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } from '../../../constants/ThemeSetting';
import './styles.less';

const SidebarContent = ({ routes }) => {
  const { uiState: { navStyle, width }, uiDispatch } = useContext(UiContext);
  const { revokeAuth } = useContext(AuthContext);
  const { pathname } = useLocation();
  const getSelected = () => {
    if (pathname.includes('cohort') || pathname.split('/')[3] === 'home') {
      return '1';
    }
    if (pathname.includes('activities')) {
      return '2';
    }
    if (pathname.includes('support')) {
      return '3';
    }
    if (pathname.includes('profile')) {
      return '4';
    }
  };
  const selectedKey = getSelected();
  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          {/* An `items` array rather than Menu children, which antd 4.20
              deprecated. The label carries the Link, so a click still
              navigates and closes the drawer on a narrow screen. */}
          <Menu
            selectedKeys={[selectedKey]}
            theme="dark"
            mode="inline"
            items={routes.map(({
              icon, title, path, key,
            }) => ({
              key,
              className: navStyle === NAV_STYLE_MINI_SIDEBAR ? 'ic-nav-item-student mini' : 'ic-nav-item-student',
              label: (
                <Link
                  to={path}
                  onClick={width < TAB_SIZE ? () => uiDispatch(toggleCollapsedSideNav(false)) : null}
                >
                  <div className="link-wrapper">
                    <span className="ic-bar" />
                    {icon}
                    <h4>{title}</h4>
                  </div>
                </Link>
              ),
            }))}
          />
        </CustomScrollbars>
      </div>
      <div className="sb-footer ic-nav-item-student">
        <Link onClick={revokeAuth} to="/">
          <div className="link-wrapper">
            <span className="ic-bar" />
            <MdKeyboardBackspace />
            <h4>Logout</h4>
          </div>
        </Link>
      </div>
    </>
  );
};

SidebarContent.propTypes = {
  routes: arrayOf(any.isRequired).isRequired,
};

export default SidebarContent;
